import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';

export enum MailGroupActionTypes {
  GetMailGroupList = '[MailGroup] Get Mail Group List',
  UpsertMailGroupList = '[MailGroup] Upsert Mail Group List',
  GetMailGroupListFail = '[MailGroup] Get Mail Group List Fail',
  AddMailGroup = '[MailGroup] Add Mail Group',
  UpdateMailGroup = '[MailGroup] Update Mail Group',
  DeleteMailGroup = '[MailGroup] Delete Mail Group',
}

export class GetMailGroupList implements Action {
  readonly type = MailGroupActionTypes.GetMailGroupList;

  constructor(public payload: any = null) {}
}
export class UpsertMailGroupList implements Action {
  readonly type = MailGroupActionTypes.UpsertMailGroupList;

  constructor(public payload: any = null) {}
}
export class GetMailGroupListFail implements Action {
  readonly type = MailGroupActionTypes.GetMailGroupListFail;
  
  constructor(public payload: any = null) {}
}
export class AddMailGroup implements Action {
  readonly type = MailGroupActionTypes.AddMailGroup;

  constructor(public payload: any = null) {}
}
export class UpdateMailGroup implements Action {
  readonly type = MailGroupActionTypes.UpdateMailGroup;

  constructor(public payload: any = null) {}
}
export class DeleteMailGroup implements Action {
  readonly type = MailGroupActionTypes.DeleteMailGroup;

  constructor(public payload: any = null) {}
}

export type MailGroupActions =
 GetMailGroupList
 | UpsertMailGroupList
 | GetMailGroupListFail
 | AddMailGroup
 | UpdateMailGroup
 | DeleteMailGroup;
